module.exports = __webpack_public_path__ + "img/buy-sell.ca98a362.jpg";